import { Address, addressToMultilineAddress, orUndefined } from '@aloft/toolkit-shared';
import { CopyButton, Flex, Typography } from '@aloft/toolkit-sui';

type ValuationTablePropertyHeaderAddressProps = {
  address: Address;
};

export const ValuationTablePropertyHeaderAddress = ({
  address,
}: ValuationTablePropertyHeaderAddressProps) => {
  const [addressLine1, addressLine2] = orUndefined(addressToMultilineAddress)(address) ?? ['', ''];
  const fullAddress = `${addressLine1} ${addressLine2}`.trim();

  return (
    <Flex
      alignItems="center"
      alignSelf="flex-start"
      gap="4px"
      minWidth={0}
      maxWidth="100%"
      overflow="hidden"
    >
      <Flex
        flexDirection="column"
        lineHeight="1.3"
        minWidth={0}
        overflow="hidden"
        whiteSpace="nowrap"
        flexShrink={1}
      >
        <Typography variant="subtitle1" truncate color="textTertiary" textAlign="left">
          {addressLine1}
        </Typography>
        <Typography variant="subtitle1" truncate color="textTertiary" textAlign="left">
          {addressLine2}
        </Typography>
      </Flex>
      <Flex flexShrink={0}>
        <CopyButton value={fullAddress} />
      </Flex>
    </Flex>
  );
};
